import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import { AbsAuthService, AntEnvService, DataService, HelperService } from '../../_services';
import { DataServiceProvider } from 'src/app/_providers';
import * as moment from 'moment';
@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css'],
  //changeDetection: ChangeDetectionStrategy.Default
})
export class AlertsComponent implements OnInit {
  lstLoginTime: any[] = [];

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    private firebaseAuth: AngularFireAuth,
    private http: HttpClient,
    private svcAuth: AbsAuthService,
    private svcAntEnv: AntEnvService,
    private svcData: DataService,
    private svcHelper: HelperService,
  ) {
    this.svcAuth = DataServiceProvider.useFactory(this.firebaseAuth, this.http, this.svcAntEnv);
  }
  
  pageData = {
    account: {
      fullName: '', email: '', password: '', confirmPassword: '', imageUrl: '', role: 'ADMIN'
      //fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    actionMode: 'NEW',
    userList: [],
    areas: []
  };
  tAccount:any; oAcc:any;
  roles = [
    {title: 'Admin', value: 'ADMIN'},
    {title: 'Normal', value: 'NORMAL'},
  ];
  alertTypes: any = [];
  users : any =[];
  areaId: any;
  emails = [];
  alertList: any = [];
  alertListDetail: any = [];
  alertIndex: any;
  frequencyIndex: any;
  _alertId: any = "";
  _alertType: any = "";
  _templateCode: any = "";
  slDisabled: boolean = false;
  slnDisabled: boolean = false;
  disabled: boolean = false;
  _isEdit: boolean = false;
  _isNew: boolean = false;
  _isList: boolean = true;
  _editId: any;
  
  roleSelected: any;
  alertTypeSelected: any;
  isLoading: false;
  ngOnInit() {
    this.dataLoad();
    this.areaListLoad();
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      var select = document.querySelectorAll('select');
      M.FormSelect.init(select, {});      
    }, 500);
  }

  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"USERMANAGEMENT-VIEW","actionCode":"USERMANAGEMENT-VIEW"}').subscribe();
  }

  dataLoad(){
    this.oAcc = this.svcAuth.getCurrentUser();
    if(!this.oAcc){
      this.router.navigate(['/login']);
      return;
    }
    this.loading(true);

    this.svcData.alertTypeList().subscribe(res=>{
      this.loading(false);
      this.alertTypes = [];
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      res.data.forEach(evt => {        
      this.alertTypes.push(evt.alertName);
      //this.alertListDetail.push({id: evt.id, alertName: evt.alertName, areaName:'', alertIndex: 0, frequencyIndex:0})
      });
    });

    this.svcData.userList().subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.userList = res.data;
      //console.log(this.pageData.userList);
      this.alertListDetails();
    });   

  }

  alertListDetails(){
    this.svcData.alertListDetails().subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.alertListDetail = [];
      //console.log(res.data);
      // var _arrEmails = [];
      // res.data.forEach((el,i) => {
      //   el.persons.forEach((eml, j) => {
      //     _arrEmails.push({alertId: el.alertId, email: eml[j].email})
      //   });
      //   _arrEmails.push()
      // });
      res.data.forEach((el,i) => {
        var _arrEmails = [];
        el.alert.persons.forEach((eml, j) => {
          _arrEmails.push(eml.email)
        });
        this.alertListDetail.push({id: el.id, alertName: el.alert.alertTitle, areaName: el.alert.areaName, alertIndex: el.alert.alertIndex, frequencyIndex:el.alert.frequencyIndex, emails: _arrEmails.toString()})
      });
      // this.alertIndex = this.alertList[0].alertIndex;
      // this.frequencyIndex = this.alertList[0].frequencyIndex;
      // this.areaId = this.alertList[0].areaId;
      // this.users = [];
      // this.alertList[0].persons.forEach(r => {
      //   this.users.push(r.email); 
      // })
    });
  }

  cancel(arg){
    this.alertTypeSelect(arg);
  }

  cancelEdit(){
    this._isEdit = false;
    this._isNew = false;
  }

  cancelNew(){
    this._isEdit = false;
    this._isNew = false;
    this._isList = true;
  }

  onChange(event) {
    //console.log(event);
    //console.log(this.users)
  }
  onChangeArea() {
    //console.log(this.areaId)
  }

  areaListLoad(){
    this.svcData.areaListForDashboard().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //console.log(res.data);
      res.data.forEach(a => {
        this.pageData.areas.push({ areaName: a.areaName, areaId: a.areaId });
      })
      //this.pageData.areas = res.data;
     
    });
  }

  onSubmit(){
    if(this.alertTypeSelected == "Capacity Alert!") { this._alertId = "A001"; this._alertType = "CAPACITY"; this._templateCode = "T-E-001"; }
    if(this.alertTypeSelected == "Sensor Status Alert") { this._alertId = "A002"; this.areaId = ""; this._alertType = "SENSOR-STATE"; this._templateCode = "T-E-002"; }
    if(this.alertTypeSelected == "Daily Count Alert") { this._alertId = "A003"; this._alertType = "DAILY-COUNT"; this._templateCode = "T-E-003"; }    
    if(this.alertTypeSelected == "No Entry Alert") { this._alertId = "A004"; this._alertType = "NO-ENTRY"; this._templateCode = "T-E-007"; }

    if(this.users.length > 0){
      this.emails = [];
      this.users.forEach(usrEmail => {
        this.emails.push({Email: usrEmail});        
      });
    }

    //console.log(this.pageData.areas);
    var _area = this.pageData.areas.filter(x => x.areaId === this.areaId);
var arg = {
      Id: this._editId,
      AlertId: this._alertId,
      AlertTitle: this.alertTypeSelected,
      AreaId: this.areaId,
      AreaName: _area.length > 0 ? _area[0].areaName: '',
      AlertIndex: this.alertIndex,
      FrequencyIndex: this.frequencyIndex,
      Persons: this.emails,
      // [
      //   { "Email": "ayhtut@gmail.com" }
      // ],
      AlertType: this._alertType,
      Status: 1,
      TemplateCode: this._templateCode
    }

    //var _isEdit = true;//this.pageData.actionMode == 'EDIT';
    if(this.alertIndex.length<1){
      this.showAlert('Alert Index should not be empty!');
      return;
    }
    if(this.frequencyIndex.length<1){
      this.showAlert('Frequency Index should not be empty!');
      return;
    }
    if(this.users.length<1){
      this.showAlert('Users should not be empty!');
      return;
    }
    if(!this.alertTypeSelected){
      this.showAlert('Please select the Alert Type');
      return;
    }

    this.loading(true);
    // var _pwdHash = this.svcHelper.aesEncrypt(this.pageData.account.password);
    // var _acc:any = {
    //   Client: { ClientId: '' },
    //   Email: this.pageData.account.email,
    //   FullName: this.pageData.account.fullName,
    //   Password: _pwdHash,
    //   Role: this.roleSelected.value
    // };
    if(this._isEdit){
     // _acc.userId = this.tAccount.userId;
      this.svcData.alertUpdateByAlertId(arg.Id, JSON.stringify(arg)).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.dataLoad();
        //this.pageData.viewMode = 'LIST';
        this.showAlert('Alert information updated!');
        this._isEdit = false;
        this._isNew = false;
        // window.setTimeout(function(){
        //   var select = document.querySelectorAll('select');
        //   M.FormSelect.init(select, {});      
        // }, 500);
      });
    }
    // else{
    //   this.svcData.userAdd(_acc).subscribe(res=>{
    //     this.loading(false);
    //     if(res.status != 'OK'){
    //       this.showAlert(res.message);
    //       return;
    //     }
    //     this.dataLoad();
    //     this.pageData.viewMode = 'LIST';
    //   });
    // }
  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  roleSelect(arg){
    this.roleSelected = arg;
  }
  alertTypeSelect(arg){
    this.alertTypeSelected = arg;
    if(this.alertTypeSelected == "Capacity Alert!") { this._alertId = "A001"; this._alertType = "CAPACITY"; this._templateCode = "T-E-001"; this.slDisabled = false; this.disabled = false; }
    if(this.alertTypeSelected == "Sensor Status Alert") { this._alertId = "A002"; this.areaId = ""; this._alertType = "SENSOR-STATE"; this._templateCode = "T-E-002"; this.slDisabled = true; this.disabled = false; }
    if(this.alertTypeSelected == "Daily Count Alert") { this._alertId = "A003"; this._alertType = "DAILY-COUNT"; this._templateCode = "T-E-003"; this.disabled = true; this.slDisabled = false; }
    if(this.alertTypeSelected == "No Entry Alert") { this._alertId = "A007"; this._alertType = "NO-ENTRY"; this._templateCode = "T-E-004"; this.slDisabled = false; this.disabled = false; }
    //this.showAlert(this.disabled)

    this.svcData.alertListByAlertId(this._editId).subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.alertList = res.data;
      //console.log(this.alertList);
      this.alertIndex = this.alertList[0].alertIndex;
      this.frequencyIndex = this.alertList[0].frequencyIndex;
      this.areaId = this.alertList[0].areaId;
      this.users = [];
      this.alertList[0].persons.forEach(r => {
        this.users.push(r.email); 
      })
      //console.log(this.users); console.log(this.areaId);
      window.setTimeout(function(){
        var select = document.querySelectorAll('select');
        M.FormSelect.init(select, {});      
      }, 500);
    });

  }

  alertTypeSelectNew(arg){
    //this.showAlert(this.slnDisabled);
    this.alertTypeSelected = arg;
    if(this.alertTypeSelected == "Capacity Alert!") { this._alertId = "A001"; this._alertType = "CAPACITY"; this._templateCode = "T-E-001"; this.slnDisabled = false; this.disabled = false; }
    if(this.alertTypeSelected == "Sensor Status Alert") { this._alertId = "A002"; this.areaId = ""; this._alertType = "SENSOR-STATE"; this._templateCode = "T-E-002"; this.slnDisabled = true; this.disabled = false; }
    if(this.alertTypeSelected == "Daily Count Alert") { this._alertId = "A003"; this._alertType = "DAILY-COUNT"; this._templateCode = "T-E-003"; this.disabled = true; this.slnDisabled = false; }
    if(this.alertTypeSelected == "No Entry Alert") { this._alertId = "A007"; this._alertType = "NO-ENTRY"; this._templateCode = "T-E-004"; this.slnDisabled = false; this.disabled = false; }
    // this.showAlert(this.slnDisabled);
    window.setTimeout(function(){
      var select = document.querySelectorAll('select');
      M.FormSelect.init(select, {});      
    }, 500);
  }

  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
    this.pageData.actionMode = arg ? 'EDIT' : 'NEW';
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);

    if(this.pageData.actionMode == 'EDIT'){
      this.tAccount = arg;
      this.pageData.account.fullName = arg.fullName;
      this.pageData.account.email = arg.email;
      this.roles.forEach(r=>{
        if(r.value == arg.role){
          this.roleSelected = r;
        }
      });
      if(this.amSA()){
        this.svcData.userConfigGet(this.tAccount.userId, 'alert.dailyCountEmail').subscribe(res=>{
          if(res.status != 'OK'){
            this.showAlert(res.message);
            return;
          }
          this.tAccount.alertDailyCountEmail = res.data == '1';
        });
      }
    }
  }
  userDelete(arg){
    if(!confirm(`Are you sure you want to delete the user "${arg.fullName}"?`)) return;

    this.svcData.userDelete(arg).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataLoad();
      this.showAlert('User successfully deleted!');
    });
  }
  userList(){
    this.pageData.viewMode = 'LIST';
  }
  amSA():boolean{
    return this.oAcc && this.oAcc.role == 'SA';
  }

  lastLoginTime(){
      this.pageData.userList.forEach((e,i) => {
          e.param1 = moment(e.lastLoginUtc).fromNow();
      });
  }

  parseDate(str: any) {
    var mdy = str.toString().split('/');
    return new Date(mdy[2], mdy[0] - 1, mdy[1]);
  }

  datediff(first, second) {        
      return Math.round((first - second) / (1000 * 60 * 60 * 24));
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  editRecord(rec:any){
    //console.log(rec);
    this._editId = rec.id;
    this._isEdit = true;
    this.dataLoad();
    this.alertTypeSelect(rec.alertName);
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      var select = document.querySelectorAll('select');
      M.FormSelect.init(select, {});      
    }, 500);
  }

  addNewAlert(){
    this._isEdit = false;
    this._isList = false;
    this._isNew = true;
    this.dataLoad();
    this.alertTypeSelected = null;
    this.alertIndex = null;
    this.frequencyIndex = null;
    this.areaId = "";
    this.users = [];
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      var select = document.querySelectorAll('select');
      M.FormSelect.init(select, {});      
    }, 500);
  }

  save(){
    if(this.alertTypeSelected == "Capacity Alert!") { this._alertId = "A001"; this._alertType = "CAPACITY"; this._templateCode = "T-E-001"; this.slDisabled = false; }
    if(this.alertTypeSelected == "Sensor Status Alert") { this._alertId = "A002"; this.areaId = ""; this._alertType = "SENSOR-STATE"; this._templateCode = "T-E-002"; this.slDisabled = true; }
    if(this.alertTypeSelected == "Daily Count Alert") { this._alertId = "A003"; this._alertType = "DAILY-COUNT"; this._templateCode = "T-E-003"; this.slDisabled = false; }    
    if(this.alertTypeSelected == "No Entry Alert") { this._alertId = "A004"; this._alertType = "NO-ENTRY"; this._templateCode = "T-E-007"; this.slDisabled = false;  }
    //(this.pageData.areas);
    if(this.users.length > 0){
      this.emails = [];
      this.users.forEach(usrEmail => {
        this.emails.push({Email: usrEmail});        
      });
    }

    var _area = this.pageData.areas.filter(x => x.areaId === this.areaId);
var arg = {
      AlertId: this._alertId,
      AlertTitle: this.alertTypeSelected,
      AreaId: this.areaId,
      AreaName: _area.length > 0 ? _area[0].areaName: '',
      AlertIndex: this.alertIndex,
      FrequencyIndex: this.frequencyIndex,
      Persons: this.emails,
      AlertType: this._alertType,
      Status: 1,
      TemplateCode: this._templateCode
    }
    if(this.alertTypeSelected != 'Daily Count Alert'){

      if(typeof(this.alertIndex) === 'undefined'){
        this.showAlert('Alert Index should not be empty!');
        return;
      }
      if(typeof(this.frequencyIndex) === 'undefined'){
        this.showAlert('Frequency Index should not be empty!');
        return;
      }

    }
    if(this.users.length<1){
      this.showAlert('Users should not be empty!');
      return;
    }
    if(!this.alertTypeSelected){
      this.showAlert('Please select the Alert Type');
      return;
    }

    this.loading(true);
      this.svcData.alertSaveNewRecord(this.oAcc.userId, JSON.stringify(arg)).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.dataLoad();
        this.showAlert('Alert information saved successfully!');
        this._isEdit = false;
        this._isNew = false;
        this._isList = true;
      });
  }

  deleteRecord(arg:any){
    //this.loading(true);
    if(!confirm(`Are you sure you want to delete the alert "${arg.alertName}"?`)) return;
    this.svcData.alertDelete(arg.id).subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataLoad();
        this.showAlert('Alert deleted successfully!');
        this._isEdit = false;
        this._isNew = false;
        this._isList = true;
    });
  }
  
}
